export const getThreadRoute = '/messages/get/';
export const sendMessageRoute = '/messages/send/';
export const sendEnterpriseMessageRoute = '/messages/enterprise-send/';
export const markUnreadRoute = '/messages/threads/markunread/';
export const getThreadsRoute = '/messages/threads/';
export const getEnterpriseThreadsRoute = '/messages/get-enterprise-threads/';
export const searchThreadsRoute = '/messages/threads/search/';
export const getUnreadMessagesInThreadRoute = '/unread/count/thread/';
export const searchEnterpriseThreadsRoute = '/messages/enterprise-search';
export const setPinThreadRoute = '/messages/threads/pinunpin';
export const threadArchiveRoute = '/messages/threads/archive/';
export const hideNotificationRote = '/notifications/read/messages';
export const writeWithAIRoute = '/ai/generate/';
